<template>
  <div class = "questionnaire-wrap">
    <Spin v-if = 'isLoading' fix></Spin>
    <div  v-for = "(item,index) in fields" :key = "index">
      <ItemField :isVertical = 'isVertical' :isPreview = 'isPreview' :ref = '`itemField${index}`' :fieldData = "item" @change = '_fieldChange'  />
    </div>
    <!-- <Button @click = "_save">保存</Button> -->
  </div>
</template>

<script>
import FieldType,{fieldInitValue} from './fieldType'
import ItemField from './itemField.vue'
export default {
  props: {
    mtId: String,
    moId: String,
    tenantId: String ,
    businessKey: String,
    busType: String,
    isPreview: Boolean,
    isVertical: Boolean,
    defaultValue: Object
  },
  components: {
    ItemField
  },
  data(){
    return {
      fields: [],//dat
      isLoading: false
    }
  },
  watch: {
    'moId': {
      handler(newValue){
        console.log(newValue)
        if(newValue){
          // this.getData()
        }
      }
    },
    'busType': {
      handler(newValue){
        console.log(newValue)
        if(newValue){
          this.getData()
        }
      }
    }
  },
  created(){
    console.log(dat)
    console.log(ItemField)
    // this.moId = '7b580b89d9bc4d38853707de6249b3ad'
    // this.busType = 'f56ccc78cf4f4fc4a252b644d6866dc4'
    // this.mtId = '64a42d2f30f34e77b95be8cc8dbd7ac3'
    // this.tenantId = JSON.parse(localStorage.user).info.tenantId
    // this.isPreview = true
    this.getData()
  },
  mounted(){
    // this.getData()
  },
  methods: {
    _verifyAllField(){
      if(this.isPreview){//预览模式不校验
        return true
      }
      let {fields} = this
      let access = true
      for(let i = 0;i<fields.length;i++){
        if(fields[i].isShow == 1&&fields[i].writeable){//显示、可编辑状态才校验
          if(this.$refs[`itemField${i}`][0].verify()){
            access = false
          }
        }
      }
      return access
    },
    _fieldChange(field){
      if(field.relation){
        this.showRelationField(field)
      }
    },
    showRelationField(field){
      console.log(field)
      this.recursionFields(this.fields,(item) => {
        if(item._releationParents && item._releationParents.length){
          let isShow = false
          for(let i in item._releationParents){
            if(item._releationParents[i].field.value == item._releationParents[i].value){
              isShow = true
            }
          }
          item.isShow = isShow
        }
      })
      // for(let i in field.relation){
      //   for(let k in field.relation[i].relation){
      //     let _field = this.getFieldByCname(field.relation[i].relation[k].fieldCname)
      //     if(_field){
      //       if(_field._releationParents.length){

      //       }
      //       if(field.relation[i].value == field.value){
      //         _field.isShow = 1
      //       }else{
              
      //       }
      //     }
      //   }
      // }
    },
    //获取表单数据
    getData(){
      if(!this.moId||!this.busType){
        return
      }
      this.isLoading = true
      this.$http.get(`/scmd/listlayout/getFormLayoutFieldList?moId=${this.moId }&busType=${this.busType}`)
      .then(({data})=>{
        console.log('问卷布局',data)
        this.isLoading = false
        if(data.returnCode == 0){
          let fields = data.beans
          this.recursionFields(fields,item => {
            if(item.relation){
              let _relation = item.relation
              for(let i in _relation){
                let _relations = _relation[i].relation
                let _value = _relation[i].value
                for(let k in _relations){
                  let _field = this.getFieldByCname(_relations[k].fieldCname,fields)
                  if(!_field){
                    continue
                  }
                  _field._releationParents = _field._releationParents || []
                  _field._releationParents.push({
                    value: _value,
                    field: item
                  })
                }
              }
            }
            item.value = fieldInitValue(item.fieldType,item)
            if(this.defaultValue&&this.defaultValue[item.fieldCname]){//字段回显传入的默认值
              item.value = this.defaultValue[item.fieldCname]
            }
            item.__value__key__ = '' //预览时展示用
          })
          this.fields = fields
          // console.log('初始化好的字段',fields)
          if(this.mtId){
            this.getAllFieldValue()
          }
        }
      })
    },
    //通过fieldCname找到对应字段对象 加下标_id是value，不加id的字段名是key
    getFieldByCname_id(fieldCname,fields){
      fields = fields || this.fields
      for(let i in fields){
        if((`${fields[i].fieldCname}_id` == fieldCname)){
          return fields[i]
        }
      }
    },
    //通过fieldCname找到对应字段对象
    getFieldByCname(fieldCname,fields){
      fields = fields || this.fields
      for(let i in fields){
        if(fields[i].fieldCname == fieldCname){
          return fields[i]
        }
      }
    },
    //遍历字段
    recursionFields(fields,cb){
      for(let i in fields){
        cb&&cb(fields[i])
      }
    },
    //获取字段值 通过mtId
    getAllFieldValue(){
      // var tenantId = JSON.parse(localStorage.user).info.tenantId
      var tenantId = this.tenantId
      var mtId = this.mtId
      var params = {
        Head: {
          method: 'select',
          version: 'v1.0'
        },
        Data: [
          {
            // optionType: 'update',
            moId: this.moId,
            OBJECT_NAME: "scmd_ask_info_"+JSON.parse(localStorage.user).info.tenantId,
            whereOf: `is_delete =0  and tenant_id=${tenantId} and mt_id=${mtId}`,
            operFields: "*",
            page: {
              pageNumber: 1,
              pageSize: 10
            }
          }
        ]
      }
      // if(!this.isPreview){
      //   params.Data[0].optionType = 'update'
      // }
      this.$http.post(`/sccm/custom/operCustom`,params).then(({data}) => {
      // this.$http.get(`scmd/fields/getFieldDetailByMtId?moId=${this.moId}&mtId=${this.mtId}`).then(({data}) => {
        console.log(data)
        if(data.returnCode == 0){
          if(!data.beans.length){
            return
          }
          let allFieldsVal = data.beans[0]
          this.businessKey = allFieldsVal.business_key
          this.recursionFields(this.fields,(itemField)=>{
            let itemValue = ''
            if(allFieldsVal[`${itemField.fieldCname}_id`]){
              itemValue = allFieldsVal[`${itemField.fieldCname}_id`]
            }else{
              itemValue = allFieldsVal[`${itemField.fieldCname}`] || ''
            }
            itemField.__value__key__ = allFieldsVal[`${itemField.fieldCname}`] || ''
            if(this.defaultValue&&this.defaultValue[itemField.fieldCname]){
              itemField.__value__key__ = this.defaultValue[itemField.fieldCname]
            }
            if(((itemField.fieldType == '4') || (itemField.fieldType == '10'&&itemField.timeType == 1))&&!this.isPreview&&itemField.writeable){
              let arr = []
              let vals = itemValue.split(',')
              for(let k in vals){
                if(vals[k]){
                  arr.push(vals[k])
                }
              }
              itemField.value = arr//.join(',')
            }else if(itemField.fieldType == '14' && this.isPreview){//查看时，类型为14的值需要格式化
              const getIndex = (str,strpram,index) => {
                  var strValue=str;
                  var strValue1="";
                  var value=0;
                  for(var i =0;i < index;i++){
                  strValue1 = strValue.substring(0,strValue.indexOf(strpram));
                  strValue = strValue.substring(strValue1.length+1);
                  value += (strValue1.length+1);
                  }
                  return value;
                }
                let _val14 = itemValue,_val141 = itemValue
                let _i = getIndex(_val14,"/",3)
                _val141 = _val141.substring(0,_i-1).split("/")
                let _val142 = _val14.substring(_i,_val14.length)
                itemField.__value__key__ = _val141.join("")+_val142
                itemField.value = itemValue
                console.log("quest===",itemField)
            }else{
              itemField.value = itemValue
            }
            this._fieldChange(itemField)
          })
          return
          //之后逻辑暂时不要
          for(let i in allFieldsVal){
            let itemField = this.getFieldByCname(i)
            if(itemField){
              //赋值
              if(((itemField.fieldType == '4') || (itemField.fieldType == '10'&&itemField.timeType == 1))&&!this.isPreview&&itemField.writeable){
                let arr = []
                let vals = allFieldsVal[i].split(',')
                for(let k in vals){
                  if(vals[k]){
                    arr.push(vals[k])
                  }
                }
                itemField.value = arr.join(',')
              }else{
                itemField.value = allFieldsVal[i]
              }
              this._fieldChange(itemField)
            }
          }
          for(let i in allFieldsVal){
            let itemField = this.getFieldByCname_id(i)
            if(itemField){
              //赋值
              if(((itemField.fieldType == '4') || (itemField.fieldType == '10'&&itemField.timeType == 1))&&!this.isPreview&&itemField.writeable){
                let arr = []
                let vals = allFieldsVal[i].split(',')
                for(let k in vals){
                  if(vals[k]){
                    arr.push(vals[k])
                  }
                }
                itemField.value = arr.join(',')
              }else{
                itemField.value = allFieldsVal[i]
              }
              this._fieldChange(itemField)
            }
            let itemFiled_key = this.getFieldByCname(i)
            if(itemFiled_key){
              itemFiled_key.__value__key__ = allFieldsVal[i]
            }
          }
        }
      })
    },
    _reset(){
      this.recursionFields(this.fields,item => {
        item.value = fieldInitValue(item.fieldType,item)
        if(this.defaultValue&&this.defaultValue[item.fieldCname]){//字段回显传入的默认值
          item.value = this.defaultValue[item.fieldCname]
        }
      })
      this.$nextTick(()=>{
        let fields = this.fields
        for(let i = 0;i<fields.length;i++){
          if(fields[i].isShow == 1&&fields[i].writeable){//显示、可编辑状态才校验
            this.$refs[`itemField${i}`][0]._reset()
          }
        }
      })
    },
    _save(params){
      // console.log(this._verifyAllField())
      if(!this._verifyAllField()|| this.isHttping){
        return false
      }
      this.isHttping = true
      console.log(this._getVal())
      if(this.mtId){
        return this._editSave()
      }else{
        return this._addSave(params)
      }
      
    },
    _getVal(){
      let val = {}
      this.recursionFields(this.fields,(field)=>{
        if(field.isShow != 0){
          //复选、时间范围特殊处理
          if(field.value && ((field.fieldType == '4') || (field.fieldType == '10'&&field.timeType == 1)) && field.value.length){
            val[field['fieldCname']] = field['value'].join(',')
            // try{
            //   val[field['fieldCname']] = field['value'].join(',')
            // }catch(e){
            //   val[field['fieldCname']] = field['value']
            // }
          }else{
            val[field['fieldCname']] = field['value']
          }
          
        }
      })
      return val
    },
    //编辑保存
    _editSave(){
      let val = this._getVal()
      val.tenant_id = this.tenantId
      val.business_key = this.businessKey
      val.business_type = this.busType
      val.whereOf = {
        mt_id: this.mtId
      }
      var _info = JSON.parse(localStorage.user).info
      val.update_by = _info.userId
      val.ask_skill_group = _info.skillIds
      val.ask_dept = _info.orgId

      var params = {
        Head: {
          moId: this.moId,
          method: 'update',
          version: 'v1.0',
          business_key: this.businessKey
        },
        Data: [
          {
            state: '',
            moId: this.moId,
            OBJECT_NAME: "scmd_ask_info_"+JSON.parse(localStorage.user).info.tenantId,
            modelId: null,
            approveTaskDate: {
              nextGroup: "",
              approveOpinion: ""
            },
            value: val
          }
        ]
      }
      console.log(val)
      return new Promise((resolve,reject) =>{
        this.$http.post('/sccm/custom/operCustom',params).then(({data}) => {
          console.log(data)
          this.isHttping = false
          if(data.returnCode == 0){
            resolve(data)
          }else{
            reject(data)
          }
        })
      })
      
    },
    //新增保存
    _addSave(origin_params){
      origin_params = origin_params || {}
      let val = this._getVal() || {}
      var _info = JSON.parse(localStorage.user).info
      val = Object.assign(origin_params,val)//合并外部参数,以本地参数为主
      if(this.tenantId){
        val.tenant_id = this.tenantId
      }else{
        val.tenant_id = _info.tenantId
      }
      val.business_type = this.busType
      val.create_by = _info.userId
      val.ask_skill_group = _info.skillIds
      val.ask_dept = _info.orgId
      if(this.businessKey){
        val.business_key = this.businessKey
      }
      val.mt_id = '@id'
      var params = {
        Head: {
          moId: this.moId,
          method: 'insert',
          version: 'v1.0'
        },
        Data: [
          {
            state: '',
            OBJECT_NAME: "scmd_ask_info_"+JSON.parse(localStorage.user).info.tenantId,
            modelId: null,
            moId: this.moId,
            approveTaskDate: {
              nextGroup: "",
              approveOpinion: ""
            },
            value: val
          }
        ]
      }
      return new Promise((resolve,reject) => {
        this.$http.post('/scmd/dynObject/operObjectCheck',params).then(({data}) => {
          this.isHttping = false
          if(data.returnCode == 0){
            if(data.bean.checkCode){
              resolve()
            }else{
              this.$Message.error(data.bean.errMsg)
            }
          }else{
            reject(data)
          }
        })
      })
      
    }
  }
}
</script>

<style scoped lang = "less">
.questionnaire-wrap{
  /* padding: 36px; */
  background:#fff;
}
</style>